import { render, staticRenderFns } from "./form-stepper-heading.vue?vue&type=template&id=232d52fd&"
import script from "./form-stepper-heading.vue?vue&type=script&lang=js&"
export * from "./form-stepper-heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports